export enum DBKeys {
  Heading = 'campaignHeading',
  Title = 'campaignTitle',
  Subtitle = 'campaignSubtitle',
  Disclaimer = 'campaignDisclaimer',
}
